import script from "./AdminSpace.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSpace.vue?vue&type=script&setup=true&lang=js"

import "./AdminSpace.vue?vue&type=style&index=0&id=1386a3a5&scoped=true&lang=scss"
import "./AdminSpace.vue?vue&type=style&index=1&id=1386a3a5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1386a3a5"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerPie from 'quasar/src/components/spinner/QSpinnerPie.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QImg,QAvatar,QBtn,QTabs,QTab,QLinearProgress,QTabPanels,QTabPanel,QInnerLoading,QSpinnerPie,QBadge,QIcon,QSeparator,QPageSticky});
